import { Routes, Route, Link } from 'react-router-dom'

function SubEvent2() {
    return(
        <>
            <div className='event-ongoing-subpage'>
              <div className='event-ongoing-subpage-subject'>
                <h1>펫키지 수다출첵 이벤트</h1>
                <p>2024-02-01 ~ 2024-02-29</p>
              </div>
              <div className='event-ongoing-subpage-img'><img src={process.env.PUBLIC_URL + '/img/.png'} /></div>
            </div>
        </>
    )
}

export default SubEvent2;